import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { classNames } from "primereact/utils";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Accordion, AccordionTab } from "primereact/accordion";

import AppMenu from "./AppMenu";
/** context */
import { useUser } from "./context/users";
import { useSettings } from "./context/settings";
import { useApolloClient } from "@apollo/client";
import { FRANCHISE } from "./provider/Franchises/query";

const AppTopbar = (props: any) => {
  const user = useUser();
  const apollo = useApolloClient();
  const franchise_id = user?.getUser()?.franchise?.id;

  const [showProfile, setShowProfile] = React.useState(false);

  const [logo, setLogo] = React.useState('assets/layout/images/logo-light.png');
  const [appName, setAppName] = React.useState('Vamos CAP');

  useEffect(() => {
    if (franchise_id) {
      apollo
      .query({
        query: FRANCHISE,
        variables: {
          id: Number(franchise_id),
        },
        fetchPolicy: "no-cache",
      })
      .then(response => {
        const data = response.data.franchise;

        if (data.logo_path && data.logo_path !== '') setLogo(data.logo_path);
        if (data.name && data.name !== '') setAppName(data.name);
      })
      .catch(error => {
        console.log('AppTopbar FRANCHISE error: ', JSON.stringify(error));
      });
    }
  }, []);

  // const onTopbarSubItemClick = (event: any) => {
  //   event.preventDefault();
  // };

  // const navigate = useNavigate();

  return (
    <>
      <div className="layout-topbar">
        <div className="layout-topbar-left">
          <button className="topbar-menu-button p-link" onClick={props.onMenuButtonClick}>
            <i className="pi pi-bars"></i>
          </button>

          {/* <button className="logo p-link" onClick={() => navigate("/")}>
            <img src={`assets/layout/images/logo-${props.colorScheme === "light" ? "dark" : "light"}.png`} alt="logo" />
          </button> */}

          <h6 className="ml-2 m-0">Vamos CAP</h6>
        </div>

        <AppMenu
          model={props.items}
          menuMode={props.menuMode}
          colorScheme={props.colorScheme}
          menuActive={props.menuActive}
          activeInlineProfile={props.activeInlineProfile}
          onSidebarMouseOver={props.onSidebarMouseOver}
          onSidebarMouseLeave={props.onSidebarMouseLeave}
          toggleMenu={props.onToggleMenu}
          onChangeActiveInlineMenu={props.onChangeActiveInlineMenu}
          onMenuClick={props.onMenuClick}
          onRootMenuItemClick={props.onRootMenuItemClick}
          onMenuItemClick={props.onMenuItemClick}
        />

        <div className="layout-topbar-right">
          <ul className="layout-topbar-right-items">
            <li id="profile" className={classNames("profile-item", { "active-topmenuitem": props.topbarMenuActive })}>
              <button className="layout-inline-menu-action p-link" onClick={props.onTopbarItemClick}>
                <img src={logo} alt={appName} />
              </button>

              <ul className="fadeInDown">
                <li role="menuitem">
                  <button className="p-link" onClick={() => setShowProfile(true)}>
                    <i className="pi pi-fw pi-user"></i>
                    <span>Perfil</span>
                  </button>
                </li>
                {/* <li role="menuitem">
                  <button className="p-link" onClick={onTopbarSubItemClick}>
                    <i className="pi pi-fw pi-cog"></i>
                    <span>Settings</span>
                  </button>
                </li> */}
                <li role="menuitem">
                  <button className="p-link" onClick={() => user?.logout()}>
                    <i className="pi pi-fw pi-sign-out"></i>
                    <span>Sair</span>
                  </button>
                </li>
              </ul>
            </li>
            {/* <li>
              <button className="p-link">
                <i className="topbar-icon pi pi-fw pi-bell"></i>
                <span className="topbar-badge">2</span>
                <span className="topbar-item-name">Notifications</span>
              </button>
            </li>
            <li>
              <button className="p-link">
                <i className="topbar-icon pi pi-fw pi-comment"></i>
                <span className="topbar-badge">5</span>
                <span className="topbar-item-name">Messages</span>
              </button>
            </li> */}
          </ul>
        </div>
      </div>

      {/* Modal informações do perfil */}
      <Dialog
        header="Meus dados"
        visible={showProfile}
        style={{ width: "90vw" }}
        modal
        footer={() => (
          <>
            <Button autoFocus type="button" label={"OK"} onClick={() => setShowProfile(false)} icon="pi pi-check" className="p-button-text" />
          </>
        )}
        onHide={() => setShowProfile(false)}>
        <div className="form-container">
          <Accordion activeIndex={0}>
            <AccordionTab header="Cadastro" tabIndex={0}>
              <p>UID: {user?.getUser()?.uid}</p>
              <p>Nome: {user?.getUser()?.name}</p>
              <p>Telefone: {user?.getUser()?.phone}</p>
              <p>ID: {user?.getUser()?.id}</p>
            </AccordionTab>
            {/* <AccordionTab header="Secretaria" tabIndex={1}>
                  <p>
                    {user?.getUser()?.descricaoSecretaria} de {user?.getUser()?.municipio}
                  </p>
                </AccordionTab>
                <AccordionTab header="Setor" tabIndex={2}>
                  <p>{user?.getUser()?.descricaoSetor}</p>
                </AccordionTab>

                <AccordionTab header="Cargo" tabIndex={3}>
                  <p>{user?.getUser()?.descricaoCargo}</p>
                </AccordionTab> */}
          </Accordion>
        </div>
      </Dialog>
    </>
  );
};

export default AppTopbar;
